export default __webpack_public_path__ + "static/dmarc360logo-7ace0cf3fee6e53e700b0fa4d2d4f89d.png";